import { ScheduleReportStatus } from 'services/api';
import type { MaybeType } from 'shared/types';

export const getSiderTitle = (type: MaybeType<ScheduleReportStatus>) => {
  if (type === ScheduleReportStatus.CRITICAL) {
    return 'Логические конфликты';
  }
  if (type === ScheduleReportStatus.WARNING) {
    return 'Конфликты СанПиН';
  }
  return 'Конфликты';
};
